/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
import React, {
  useEffect, useRef, useState,
} from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import BottomSheet from '../filterBottomSheet/BottomSheet';
import pdfFile from '../../../public/assets/pdfFile.svg';
import announcementIcon from '../../../public/assets/Vector.svg';
import feedback from '../../../public/assets/feedback.svg';
import downloadIcon from '../../../public/assets/downloadIcon.svg';
import { encodeBase64String } from '../../utils/helpers';
import askdoubt from '../../../public/assets/ask-doubts.png';

function TagView({
  tags, onTagClick, tagName, brochure, batchId, pageType, className, liClassName, divClassName, attendanceFlag, setIsFeedBackShow, unseenAnnouncementsData, handleAnnouncementIconClick = {}, pageName = '', router,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isBottomSheetOpen, setBottomSheetOpen] = useState(false);
  const menuRef = useRef(null);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [openSubMenuBottom, setShowSubMenuBottom] = useState(false);

  // ─────────────────────────────────────────────────────────────────────────

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
    setBottomSheetOpen((prev) => !prev);
  };

  // const handleOpen = () => setBottomSheetOpen(true);
  const handleClose = () => {
    setBottomSheetOpen(false);
    setShowSubMenuBottom(false);
    // setShowDropdown(false);
  };

  const showFeedBackForm = () => {
    // console.log('feedback form');
    setBottomSheetOpen(false);
    setIsFeedBackShow(true);
    setIsOpen((prev) => !prev);
  };
  const handleStudyPlanDownlod = (url) => {
    if (url) {
      window.open(url, '_blank');
    }
  };
  const handleClickSubMenu = () => {
    setShowSubMenuBottom((prev) => !prev);
    setBottomSheetOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const formatTag = (name) => {
    if (name.toLowerCase() === name) return 'Test Series';
    return name
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const hasUnseenAnnouncements = unseenAnnouncementsData?.hasUnseenAnnouncements;
  const unseenAnnouncements = unseenAnnouncementsData?.unseenAnnouncements;
  return (
    <>
      <div className={`flex justify-between lg:border-b lg:border-[#DADADA]  ${divClassName} lg:bg-transparent relative`}>
        <ul className={`flex gap-x-10 lg:justify-start ${className}`}>
          {tags.map((tag) => (
            <li
              key={tag.name}
              className={`${tagName === tag.name ? 'text-customBlue font-semibold activelist' : 'text-[#7d93a9]'
              } lg:text-base text-xs font-normal leading-[20px] cursor-pointer whitespace-nowrap li-divide text-center relative ${liClassName}`}
              onClick={() => onTagClick(tag)}
            >
              {formatTag(tag.name)}
            </li>
          ))}
        </ul>
        {
            pageType === 'courseActive' && pageName === 'my-course'
            && (
              <div className="items-center mt-2 md:mt-0 lg:relative lg:top-0 absolute top-[55px] right-0 hidden">
                <div className="pr-3 cursor-pointer" onClick={() => router.push('/doubt/my-doubts')}>
                  <Image src={askdoubt} width={500} height={500} alt="announcementIcon" className="lg:w-6 lg:h-6 w-[22px] h-[22px]" />
                </div>
                <div className="relative cursor-pointer" onClick={handleAnnouncementIconClick} data-announcement-icon>
                  <Image src={announcementIcon} width={500} height={500} alt="announcementIcon" className="lg:w-[26px] lg:h-[24px] w-[22px] h-[22px]" />
                  {hasUnseenAnnouncements && unseenAnnouncements > 0 && (
                  <span className="absolute -top-1 -left-1 min-w-[16px] h-[16px] px-[5px] flex items-center justify-center rounded-full bg-[#FF3B30] text-white text-[10px] leading-none font-semibold">
                    {unseenAnnouncements}
                  </span>
                  )}
                </div>
              </div>
            )
          }
        <div ref={menuRef} className={`menu-wrapper cursor-pointer flex items-center ${pageType === 'courseActive' ? 'hidden' : ''}`}>
          <div className="wrap" onClick={toggleMenu}>
            <svg className="lg:w-[30px] lg:h-[30px] w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_951_85888)">
                <path d="M12.0003 0.856934C9.79643 0.856934 7.64208 1.51045 5.80964 2.73484C3.97721 3.95924 2.549 5.69951 1.70563 7.7356C0.86225 9.77169 0.641584 12.0121 1.07153 14.1737C1.50148 16.3352 2.56274 18.3206 4.12109 19.879C5.67945 21.4373 7.66492 22.4986 9.82642 22.9285C11.9879 23.3585 14.2284 23.1378 16.2645 22.2944C18.3006 21.4511 20.0408 20.0229 21.2652 18.1904C22.4896 16.358 23.1431 14.2036 23.1431 11.9998C23.1398 9.04555 21.9647 6.21326 19.8758 4.12429C17.7868 2.03532 14.9545 0.860276 12.0003 0.856934ZM12.0003 22.2512C9.97274 22.2512 7.99073 21.65 6.30489 20.5235C4.61906 19.3971 3.3051 17.796 2.5292 15.9228C1.75329 14.0496 1.55028 11.9884 1.94583 9.99983C2.34139 8.01125 3.31774 6.18462 4.75143 4.75094C6.18512 3.31725 8.01175 2.34089 10.0003 1.94534C11.9889 1.54979 14.0501 1.7528 15.9233 2.52871C17.7965 3.30461 19.3976 4.61856 20.524 6.3044C21.6505 7.99024 22.2517 9.97225 22.2517 11.9998C22.2486 14.7177 21.1676 17.3234 19.2457 19.2452C17.3239 21.1671 14.7182 22.2481 12.0003 22.2512Z" fill="black" />
                <path d="M12.741 12.495C12.839 12.3484 12.8913 12.1761 12.8913 11.9998C12.891 11.7634 12.797 11.5368 12.6299 11.3697C12.4627 11.2026 12.2362 11.1086 11.9998 11.1083C11.8235 11.1083 11.6512 11.1606 11.5046 11.2586C11.358 11.3565 11.2437 11.4957 11.1763 11.6586C11.1088 11.8215 11.0911 12.0008 11.1255 12.1737C11.1599 12.3466 11.2448 12.5054 11.3695 12.6301C11.4942 12.7548 11.653 12.8397 11.8259 12.8741C11.9988 12.9085 12.1781 12.8908 12.341 12.8233C12.5038 12.7559 12.6431 12.6416 12.741 12.495Z" fill="black" />
                <path d="M12.741 17.8436C12.839 17.697 12.8913 17.5246 12.8913 17.3483C12.891 17.112 12.797 16.8854 12.6299 16.7183C12.4627 16.5512 12.2362 16.4572 11.9998 16.4569C11.8235 16.4569 11.6512 16.5092 11.5046 16.6071C11.358 16.7051 11.2437 16.8443 11.1763 17.0072C11.1088 17.1701 11.0911 17.3493 11.1255 17.5222C11.1599 17.6952 11.2448 17.854 11.3695 17.9787C11.4942 18.1033 11.653 18.1882 11.8259 18.2226C11.9988 18.257 12.1781 18.2394 12.341 18.1719C12.5038 18.1044 12.6431 17.9902 12.741 17.8436Z" fill="black" />
                <path d="M12.741 7.14645C12.839 6.99985 12.8913 6.8275 12.8913 6.65119C12.891 6.41486 12.797 6.18827 12.6299 6.02116C12.4627 5.85404 12.2362 5.76004 11.9998 5.75977C11.8235 5.75977 11.6512 5.81205 11.5046 5.91C11.358 6.00795 11.2437 6.14717 11.1763 6.31006C11.1088 6.47295 11.0911 6.65218 11.1255 6.8251C11.1599 6.99802 11.2448 7.15686 11.3695 7.28153C11.4942 7.4062 11.653 7.4911 11.8259 7.52549C11.9988 7.55989 12.1781 7.54224 12.341 7.47477C12.5038 7.4073 12.6431 7.29304 12.741 7.14645Z" fill="black" />
                <path d="M12.741 12.495C12.839 12.3484 12.8913 12.1761 12.8913 11.9998C12.891 11.7634 12.797 11.5368 12.6299 11.3697C12.4627 11.2026 12.2362 11.1086 11.9998 11.1083C11.8235 11.1083 11.6512 11.1606 11.5046 11.2586C11.358 11.3565 11.2437 11.4957 11.1763 11.6586C11.1088 11.8215 11.0911 12.0008 11.1255 12.1737C11.1599 12.3466 11.2448 12.5054 11.3695 12.6301C11.4942 12.7548 11.653 12.8397 11.8259 12.8741C11.9988 12.9085 12.1781 12.8908 12.341 12.8233C12.5038 12.7559 12.6431 12.6416 12.741 12.495Z" stroke="black" strokeWidth="1.5" />
                <path d="M12.741 17.8436C12.839 17.697 12.8913 17.5246 12.8913 17.3483C12.891 17.112 12.797 16.8854 12.6299 16.7183C12.4627 16.5512 12.2362 16.4572 11.9998 16.4569C11.8235 16.4569 11.6512 16.5092 11.5046 16.6071C11.358 16.7051 11.2437 16.8443 11.1763 17.0072C11.1088 17.1701 11.0911 17.3493 11.1255 17.5222C11.1599 17.6952 11.2448 17.854 11.3695 17.9787C11.4942 18.1033 11.653 18.1882 11.8259 18.2226C11.9988 18.257 12.1781 18.2394 12.341 18.1719C12.5038 18.1044 12.6431 17.9902 12.741 17.8436Z" stroke="black" strokeWidth="1.5" />
                <path d="M12.741 7.14645C12.839 6.99985 12.8913 6.8275 12.8913 6.65119C12.891 6.41486 12.797 6.18827 12.6299 6.02116C12.4627 5.85404 12.2362 5.76004 11.9998 5.75977C11.8235 5.75977 11.6512 5.81205 11.5046 5.91C11.358 6.00795 11.2437 6.14717 11.1763 6.31006C11.1088 6.47295 11.0911 6.65218 11.1255 6.8251C11.1599 6.99802 11.2448 7.15686 11.3695 7.28153C11.4942 7.4062 11.653 7.4911 11.8259 7.52549C11.9988 7.55989 12.1781 7.54224 12.341 7.47477C12.5038 7.4073 12.6431 7.29304 12.741 7.14645Z" stroke="black" strokeWidth="1.5" />
              </g>
              <defs><clipPath id="clip0_951_85888"><rect width="24" height="24" fill="white" /></clipPath></defs>
            </svg>

          </div>
          {/* Dropdown Menu desktop */}
          {isOpen && (
          <div className="absolute hidden lg:block right-0 top-[33px] w-48 bg-white rounded-lg shadow-md border border-[#B9E6FF] border-b-4 border-b-[#00C3FF] z-50">
            <ul className="py-2">
              {
            brochure?.length > 0
              && (
                <li>
                  <div
                    className="flex items-center justify-between px-4 py-2 hover:bg-[#B9E6FF] cursor-pointer"
                    onClick={() => (brochure?.length > 1 ? setShowSubMenu(!showSubMenu) : handleStudyPlanDownlod(brochure?.[0]?.url))}
                  >
                    <div className="flex items-center text-[#334155] text-sm font-medium ">
                      <Image src={pdfFile} alt="PDF Icon" width={26} height={26} className="mr-3" />
                      Study Plan
                    </div>
                    {
                      brochure?.length > 1 ? (
                        <span className={`${showSubMenu ? 'rotate-90' : ''}`}>
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                          </svg>
                        </span>
                      ) : <Image width={25} height={25} src={downloadIcon} alt="download Icon" />
                    }

                  </div>

                  {/* Inline expanded items */}
                  {showSubMenu && (
                  <>
                    {brochure.map((item, index) => (
                      <div
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        onClick={() => handleStudyPlanDownlod(item?.url)}
                        className="pr-4 py-2 hover:bg-[#B9E6FF] cursor-pointer pl-6 text-sm flex justify-between items-center"
                      >
                        <div className="flex items-center">

                          <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="7" height="7" rx="3.5" fill="#323943" />
                          </svg>

                          <span className="pl-1.5">
                            {' '}
                            {item?.name}
                          </span>
                        </div>
                        <Image width={25} height={25} src={downloadIcon} alt="download Icon" />
                      </div>
                    ))}
                  </>
                  )}
                </li>
              )
}
              <li className="flex items-center px-4 py-2 hover:bg-[#B9E6FF] cursor-pointer" onClick={showFeedBackForm}>
                <Image
                  width={500}
                  height={500}
                  src={feedback}
                  alt="Feedback Icon"
                  className="w-[26px] h-[26px] mr-3"
                />
                <span className="text-[#334155] text-sm font-medium flex-1">
                  Give Feedback
                </span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                </svg>
              </li>
              {
                attendanceFlag

              && (
              <li className="flex items-center px-4 py-2 hover:bg-[#B9E6FF] cursor-pointer">
                <span className="mr-3">

                  <svg width="26" height="26" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="15.4737" cy="13.4737" r="8.47368" fill="#B8E5FF" />
                    <mask id="path-2-inside-1_6407_11172" fill="white">
                      <path d="M25.4645 4.37891V20.1655C25.4645 21.2701 24.5691 22.1655 23.4645 22.1655H6.49463C5.39006 22.1655 4.49463 21.2701 4.49463 20.1655V13.2722V4.37891" />
                    </mask>
                    <path d="M24.6645 4.37891V20.1655H26.2645V4.37891H24.6645ZM23.4645 21.3655H6.49463V22.9655H23.4645V21.3655ZM5.29463 20.1655V13.2722H3.69463V20.1655H5.29463ZM5.29463 13.2722V4.37891H3.69463V13.2722H5.29463ZM6.49463 21.3655C5.83189 21.3655 5.29463 20.8283 5.29463 20.1655H3.69463C3.69463 21.7119 4.94823 22.9655 6.49463 22.9655V21.3655ZM24.6645 20.1655C24.6645 20.8283 24.1273 21.3655 23.4645 21.3655V22.9655C25.0109 22.9655 26.2645 21.7119 26.2645 20.1655H24.6645Z" fill="#217ABB" mask="url(#path-2-inside-1_6407_11172)" />
                    <path d="M14.9998 2H13.9165V4.15875H14.9998V2Z" fill="#217ABB" />
                    <path d="M20.6606 23.9307H9.74268V24.753H20.6606V23.9307Z" fill="#217ABB" />
                    <path d="M8.76341 21.7632H8.22119V28.0001H8.76341V21.7632Z" fill="#217ABB" />
                    <path d="M20.9587 21.7632H20.4165V28.0001H20.9587V21.7632Z" fill="#217ABB" />
                    <path d="M17.3632 11.372C17.3632 12.694 16.3072 13.7564 15.0159 13.7564C13.7245 13.7564 12.6686 12.694 12.6686 11.372C12.6686 10.0501 13.7245 8.98765 15.0159 8.98765C16.3072 8.98765 17.3632 10.0501 17.3632 11.372Z" stroke="#217ABB" strokeWidth="0.8" />
                    <path d="M15.0161 15.4715C17.013 15.4715 18.7218 17.1848 18.9425 19.4708H11.0897C11.3104 17.1848 13.0191 15.4715 15.0161 15.4715Z" stroke="#217ABB" strokeWidth="0.8" />
                    <path d="M27.451 4.1958H2.54897C2.24578 4.1958 2 4.44158 2 4.74477C2 5.04796 2.24578 5.29375 2.54897 5.29375H27.451C27.7542 5.29375 28 5.04796 28 4.74477C28 4.44158 27.7542 4.1958 27.451 4.1958Z" fill="#217ABB" />
                  </svg>

                </span>
                <a href={`/prep/attendance/${batchId}?studyPlan=${encodeBase64String('1')}`} className="text-[#334155] text-sm font-medium flex-1">
                  Attendance
                </a>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                </svg>
              </li>
              )
}
              <li className="flex items-center px-4 py-2 hover:bg-[#B9E6FF] cursor-pointer">
                <span className="mr-3">

                  <svg width="26" height="26" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="15.4737" cy="13.4737" r="8.47368" fill="#B8E5FF" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M9 4H21C22.6569 4 24 5.4071 24 7.14286V22.8571C24 24.5929 22.6569 26 21 26H9C7.34315 26 6 24.5929 6 22.8571V7.14286C6 5.4071 7.34315 4 9 4Z" stroke="#217ABB" strokeLinecap="round" strokeLinejoin="round" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M10.4999 4H16.4999V11.876L13.4999 8.71429L10.4999 11.876V4Z" stroke="#0267B1" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>

                </span>
                <a href={`/prep/bookmarks/${batchId}`} className="text-[#334155] text-sm font-medium flex-1">
                  Bookmarks
                </a>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                </svg>
              </li>
            </ul>
          </div>
          )}
        </div>
      </div>

      {/* Bottom Sheet for Mobile */}
      {isBottomSheetOpen && (
        <BottomSheet
          isOpen={isBottomSheetOpen}
          onClose={handleClose}
          initialHeight="40%"
          pageName="study plan"
        >
          <ul className="py-2">
            {
              brochure?.length > 0

            && (
            <li className="flex items-center px-4 py-2 hover:bg-[#B9E6FF] cursor-pointer">
              <span onClick={() => (brochure?.length > 1 ? handleClickSubMenu() : handleStudyPlanDownlod(brochure?.[0]?.url))} className="flex items-center w-full">
                <Image
                  width={500}
                  height={500}
                  src={pdfFile}
                  alt="PDF Icon"
                  className="w-[26px] h-[26px] mr-3"
                />
                <span className="text-[#334155] text-md font-semibold flex-1">
                  Study Plan
                </span>
                {
                  brochure?.length > 1 ? (
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
                      <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                    </svg>
                  ) : <Image width={30} height={30} src={downloadIcon} alt="download Icon" />
                }
              </span>
            </li>
            )
}
            <li className="flex items-center px-4 py-2 hover:bg-[#B9E6FF] cursor-pointer" onClick={showFeedBackForm}>
              <Image
                width={500}
                height={500}
                src={feedback}
                alt="Feedback Icon"
                className="w-[26px] h-[26px] mr-3"
              />
              <span className="text-[#334155] text-md font-semibold flex-1">
                Give Feedback
              </span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
                <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
              </svg>
            </li>
            {
                attendanceFlag
              && (
              <li className="flex items-center px-4 py-2 hover:bg-[#B9E6FF] cursor-pointer">
                <a className="flex items-center flex-1 justify-between" href={`/prep/attendance/${batchId}?studyPlan=${encodeBase64String('1')}`}>
                  <span className="flex">
                    <span className=" mr-3">
                      <svg width="26" height="26" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="15.4737" cy="13.4737" r="8.47368" fill="#B8E5FF" />
                        <mask id="path-2-inside-1_6407_11172" fill="white">
                          <path d="M25.4645 4.37891V20.1655C25.4645 21.2701 24.5691 22.1655 23.4645 22.1655H6.49463C5.39006 22.1655 4.49463 21.2701 4.49463 20.1655V13.2722V4.37891" />
                        </mask>
                        <path d="M24.6645 4.37891V20.1655H26.2645V4.37891H24.6645ZM23.4645 21.3655H6.49463V22.9655H23.4645V21.3655ZM5.29463 20.1655V13.2722H3.69463V20.1655H5.29463ZM5.29463 13.2722V4.37891H3.69463V13.2722H5.29463ZM6.49463 21.3655C5.83189 21.3655 5.29463 20.8283 5.29463 20.1655H3.69463C3.69463 21.7119 4.94823 22.9655 6.49463 22.9655V21.3655ZM24.6645 20.1655C24.6645 20.8283 24.1273 21.3655 23.4645 21.3655V22.9655C25.0109 22.9655 26.2645 21.7119 26.2645 20.1655H24.6645Z" fill="#217ABB" mask="url(#path-2-inside-1_6407_11172)" />
                        <path d="M14.9998 2H13.9165V4.15875H14.9998V2Z" fill="#217ABB" />
                        <path d="M20.6606 23.9307H9.74268V24.753H20.6606V23.9307Z" fill="#217ABB" />
                        <path d="M8.76341 21.7632H8.22119V28.0001H8.76341V21.7632Z" fill="#217ABB" />
                        <path d="M20.9587 21.7632H20.4165V28.0001H20.9587V21.7632Z" fill="#217ABB" />
                        <path d="M17.3632 11.372C17.3632 12.694 16.3072 13.7564 15.0159 13.7564C13.7245 13.7564 12.6686 12.694 12.6686 11.372C12.6686 10.0501 13.7245 8.98765 15.0159 8.98765C16.3072 8.98765 17.3632 10.0501 17.3632 11.372Z" stroke="#217ABB" strokeWidth="0.8" />
                        <path d="M15.0161 15.4715C17.013 15.4715 18.7218 17.1848 18.9425 19.4708H11.0897C11.3104 17.1848 13.0191 15.4715 15.0161 15.4715Z" stroke="#217ABB" strokeWidth="0.8" />
                        <path d="M27.451 4.1958H2.54897C2.24578 4.1958 2 4.44158 2 4.74477C2 5.04796 2.24578 5.29375 2.54897 5.29375H27.451C27.7542 5.29375 28 5.04796 28 4.74477C28 4.44158 27.7542 4.1958 27.451 4.1958Z" fill="#217ABB" />
                      </svg>
                    </span>
                    <span className="text-[#334155] text-md font-semibold flex-1">
                      Attendance
                    </span>
                  </span>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
                    <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                  </svg>
                </a>
              </li>
              )
}
            <li className="flex items-center px-4 py-2 hover:bg-[#B9E6FF] cursor-pointer">
              <a className="flex items-center flex-1 justify-between" href={`/prep/bookmarks/${batchId}`}>
                <span className="flex">
                  <span className=" mr-3">
                    <svg width="26" height="26" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="15.4737" cy="13.4737" r="8.47368" fill="#B8E5FF" />
                      <path fillRule="evenodd" clipRule="evenodd" d="M9 4H21C22.6569 4 24 5.4071 24 7.14286V22.8571C24 24.5929 22.6569 26 21 26H9C7.34315 26 6 24.5929 6 22.8571V7.14286C6 5.4071 7.34315 4 9 4Z" stroke="#217ABB" strokeLinecap="round" strokeLinejoin="round" />
                      <path fillRule="evenodd" clipRule="evenodd" d="M10.4999 4H16.4999V11.876L13.4999 8.71429L10.4999 11.876V4Z" stroke="#0267B1" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span className="text-[#334155] text-md font-semibold flex-1">
                    Bookmarks
                  </span>
                </span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                </svg>
              </a>
            </li>
          </ul>
        </BottomSheet>
      )}

      {openSubMenuBottom && (
      <BottomSheet
        isOpen={openSubMenuBottom}
        onClose={handleClose}
        initialHeight="40%"
        pageName="study plan"
      >
        <ul className="py-2">
          {
              brochure?.map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <li key={index} className="flex items-center px-4 py-2 hover:bg-[#B9E6FF] cursor-pointer">
                  <span onClick={() => handleStudyPlanDownlod(item?.url)} className="flex items-center w-full">
                    <Image
                      width={500}
                      height={500}
                      src={pdfFile}
                      alt="PDF Icon"
                      className="w-[26px] h-[26px] mr-3"
                    />
                    <span className="text-[#334155] text-md font-semibold flex-1">
                      {item?.name}
                    </span>
                    <Image width={30} height={30} src={downloadIcon} alt="download Icon" />
                  </span>
                </li>
              ))
}

        </ul>
      </BottomSheet>
      )}

    </>
  );
}

TagView.propTypes = {
  tags: PropTypes.any.isRequired,
  tagName: PropTypes.any.isRequired,
  onTagClick: PropTypes.func.isRequired,
  brochure: PropTypes.any,
  batchId: PropTypes.any,
  pageType: PropTypes.any,
  // courseName: PropTypes.any,
  // showFeedBack: PropTypes.any,
  className: PropTypes.any,
  liClassName: PropTypes.any,
  divClassName: PropTypes.any,
  // setzIndexClass: PropTypes.any,
  attendanceFlag: PropTypes.any,
  setIsFeedBackShow: PropTypes.any,
  unseenAnnouncementsData: PropTypes.any,
  handleAnnouncementIconClick: PropTypes.func,
  pageName: PropTypes.string,
  router: PropTypes.any,
};
// TagView.defaultProps = {
//   brochure: null,
//   batchId: null,
//   pageType: '',
//   courseName: '',
//   showFeedBack: false,
//   className: '',
//   liClassName: '',
//   divClassName: '',
//   attendanceFlag: false,
//   setIsFeedBackShow: () => {},
//   unseenAnnouncementsData: null,
//   handleAnnouncementIconClick: () => {},
//   pageName: '',
//   router: null,
// };
export default TagView;
